/**
 * @file
 * Pointer and arrow-key reordering of a container.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;

  // Pointer + arrow-key reordering of a container's items. A 5px threshold
  // keeps plain clicks working; the DOM reorders live and the caller commits
  // from it: onCommit() after a drag, onKeyCommit(item) after a key move.
  components.dragReorder = ({
    container,
    selector,
    ignore,
    canDrag,
    onCommit,
    onKeyCommit,
  }) => {
    let drag = null;
    container.addEventListener('pointerdown', (event) => {
      const item = event.target.closest(selector);
      if (!item || (ignore && event.target.closest(ignore))) {
        return;
      }
      if (canDrag && !canDrag()) {
        return;
      }
      drag = {
        item,
        x: event.clientX,
        y: event.clientY,
        id: event.pointerId,
        active: false,
      };
    });
    container.addEventListener('pointermove', (event) => {
      if (!drag) {
        return;
      }
      if (!drag.active) {
        if (Math.hypot(event.clientX - drag.x, event.clientY - drag.y) < 5) {
          return;
        }
        drag.active = true;
        drag.item.classList.add('is-dragging');
        drag.item.setPointerCapture(drag.id);
        // No bubbles while dragging over other items.
        berTags.tooltip.suspend();
      }
      const over = document
        .elementsFromPoint(event.clientX, event.clientY)
        .map((node) => node.closest && node.closest(selector))
        .find(
          (node) =>
            node && node !== drag.item && node.parentElement === container,
        );
      if (over) {
        const rect = over.getBoundingClientRect();
        const before =
          event.clientY < rect.top + rect.height / 2 ||
          (event.clientY < rect.bottom &&
            event.clientX < rect.left + rect.width / 2);
        container.insertBefore(
          drag.item,
          before ? over : over.nextElementSibling,
        );
      }
    });
    const end = () => {
      if (!drag) {
        return;
      }
      const { active } = drag;
      drag.item.classList.remove('is-dragging');
      drag = null;
      if (active) {
        berTags.tooltip.resume();
        onCommit();
      }
    };
    // Document level on purpose: insertBefore reparents the dragged item,
    // which silently releases its pointer capture - a release over a gap
    // or past the last item would never reach the container, leaving the
    // drag (and the suspended tooltip) stuck.
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
    container.addEventListener('keydown', (event) => {
      const item = event.target.closest(selector);
      if (!item || item !== event.target) {
        return;
      }
      const list = [...container.querySelectorAll(selector)];
      const i = list.indexOf(item);
      let to = i;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        to = i - 1;
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        to = i + 1;
      } else {
        return;
      }
      if (to < 0 || to >= list.length) {
        return;
      }
      event.preventDefault();
      container.insertBefore(
        item,
        to < i ? list[to] : list[to].nextElementSibling,
      );
      onKeyCommit(item);
    });
  };
})(Drupal);
